import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const STATUS_OPTS = [
  ["estimating", "Estimating"],
  ["proposal", "Proposal"],
  ["sent", "Sent"],
];

// Pick a new status for a batch of bids/estimates.
export function BidStatusDialog({ open, onOpenChange, count, onConfirm }) {
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => { if (!status) return; setBusy(true); try { await onConfirm(status); } finally { setBusy(false); } };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) setStatus(""); onOpenChange(o); }}>
      <DialogContent data-testid="status-dialog">
        <DialogHeader>
          <DialogTitle>Change status · {count} estimate{count === 1 ? "" : "s"}</DialogTitle>
          <DialogDescription>Move the selected {count === 1 ? "estimate" : "estimates"} to a new stage.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {STATUS_OPTS.map(([k, lab]) => (
            <button key={k} data-testid={`status-opt-${k}`} onClick={() => setStatus(k)}
              className={`text-sm px-3 py-2 rounded-lg border transition-colors ${status === k ? "bg-[#003E87] text-white border-[#003E87]" : "text-slate-600 border-slate-200 hover:bg-slate-50"}`}>{lab}</button>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="status-cancel">Cancel</Button>
          <Button disabled={!status || busy} onClick={submit} data-testid="status-confirm" className="bg-[#003E87] hover:bg-[#00305F] text-white">Apply</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
